fx.ns("filters", class ThemeCategoryFilter extends fx.Filter {

	constructor()
	{
        super();
    }

    get categoryid()
    {
        return this._categoryid;
    }

    set categoryid(val)
    {
        this._categoryid = val;
        this._changed = true;
    }

   
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        if (this.categoryid)
        {
            for (let i = 0; i < this.rawData.length; i++)
            {
                let themecategory = this.rawData.getItemAt( [i] );

                if (themecategory.theme_category_id == this.categoryid && fx.service("LangService").current.id == themecategory.id_lang)
                    this.transformedData.push( themecategory );
            }
        }

		return this.transformedData;
	}	
});